module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/core-js/library/modules/$.strict-new.js
// module id = 72
// module chunks = 0